import * as React from 'react';
import { ApiRoomDetails } from '../../ApiTypes';

type RoomDetailContextProps = {
    roomDetails: ApiRoomDetails;
    setRoomDetails: React.Dispatch<ApiRoomDetails>;
};

export const RoomDetailContext = React.createContext({} as RoomDetailContextProps);
